import { useState } from "react";
import { Modal } from "react-bootstrap";
import { deleteVendorById } from "../../../api/projects";
import { useVendorHooks } from "../../../utils/project/VendorUtils";
import AlertBox from "../../AlertBox";

export default function ModalVendorDelete({ show, id, onClose, onSuccess }) {
  let {data} = useVendorHooks({id});
  const [alert, setAlert] = useState({show: false, message: '', type: ''});
  let [loading, setLoading] = useState(false);

  const handleClose = () => {
    if (!loading) {
      setAlert({show: false, message: '', type: ''});
      onClose();
    }
  }

  const onDelete = async () => {
    setLoading(true);
    try {
      let response = await deleteVendorById(id);
      onSuccess(true, response.data.message);
      handleClose();
    } catch (error) {
      let message = ""
      if (error.response) {
        let { data } =  error.response;
        message = data.message;
      } else {
        message = "Something Error Happened";
      }

      setAlert({show: true, message, type: 'danger'})
    }

    setLoading(false);
  }

  return(
    <Modal show={show} onHide={() => handleClose()}>
      <Modal.Header closeButton>
        <Modal.Title>Hapus Data Vendor</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <AlertBox { ...alert } setAlert={setAlert} />
        <h5 className="text-gray-800">Apakah anda yakin akan menghapus vendor "{data.name}"?</h5>
      </Modal.Body>
      <Modal.Footer>
        <button className="btn btn-default" onClick={() => handleClose()}>Tidak</button>
        <button className="btn btn-danger" onClick={() => onDelete()} disabled={loading}>{loading ? 'Menunggu ...' : 'Ya'}</button>
      </Modal.Footer>
    </Modal>
  )
}